import CustomDrawer from "../../../../../../components/CustomDrawer";
import ShiftAdd from "./ShiftAdd";
import ShiftList from "./ShiftList";

type Props = {
  data?: string;
  type?: string;
  open: boolean;
  handleClose: (value?: boolean) => void;
};

export default function AssignShift({ type, data, open, handleClose }: Props) {
  return (
    <CustomDrawer
      width={850}
      open={open}
      onClose={handleClose}
      title={`${type === "UPDATE" ? "Update" : "Add"} Shift & Assign`}
    >
      <ShiftAdd shiftId={data} />
      <div className="mb-6" />
      <ShiftList />
    </CustomDrawer>
  );
}
